/**
 * Status pill for an auction run — green = completed, orange = draft,
 * red = failed. Extracted from WholesaleReportsPage's statusBadge so the
 * Reports table and the Run List page's run switcher render status
 * identically (frontend-standards §4). Semantic fills are rgba tints of the
 * THEME semantic colors (same approach the alert panels use, since there's
 * no tinted-semantic token yet).
 */
import React from "react"

import { THEME } from "../../config/theme"

interface Props {
  status: string
}

export default function AuctionStatusPill({ status }: Props) {
  const { bg, fg, label } = styleFor(status)
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: THEME.borderRadius.pill,
        background: bg,
        color: fg,
        fontSize: 11,
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  )
}

function styleFor(status: string): { bg: string; fg: string; label: string } {
  if (status === "completed") {
    return {
      bg: "rgba(34, 197, 94, 0.12)",
      fg: THEME.colors.semantic.success,
      label: "Completed",
    }
  }
  if (status === "draft") {
    return {
      bg: "rgba(217, 119, 6, 0.12)",
      fg: THEME.colors.semantic.warning,
      label: "Draft",
    }
  }
  // "failed" or anything unexpected — surface it in danger styling.
  return {
    bg: "rgba(220, 38, 38, 0.12)",
    fg: THEME.colors.semantic.danger,
    label: status === "failed" ? "Failed" : status,
  }
}
